export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
export const FUNCTIONS_URL = process.env.REACT_APP_FUNCTIONS_URL;

export const DATOCMS_BASE_URL = process.env.REACT_APP_DATOCMS_BASE_URL;
export const DATOCMS_ASK_LUNA_QUESTION_ITEM_ID = process.env.REACT_APP_DATOCMS_ASK_LUNA_QUESTION_ITEM_ID;

export const IS_PROD = ENVIRONMENT === 'prod';

export const IS_DEV_MODE: boolean =
  window?.location.href.indexOf('localhost') > -1;
